import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from '../shared/shared.module';

import { AboutUsComponent } from './about-us/about-us.component'
import { ActualiteComponent } from './actualite/actualite.component'
import { ActualitesComponent } from './actualites/actualites.component'
import { FaqPageComponent } from './faq-page/faq-page.component'
import { JobComponent } from './job/job.component'
import { JobsComponent } from './jobs/jobs.component'
import { ProductPageComponent } from './product-page/product-page.component'
import { ProductsComponent } from './products/products.component'
import { RdComponent } from './rd/rd.component'
import { RdPageComponent } from './rd-page/rd-page.component'
import { RegisterComponent } from './register/register.component'
import { SecurityDayComponent } from './security-day/security-day.component'
import { TarifsComponent } from './tarifs/tarifs.component';
import { BasketComponent } from './basket/basket.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ConstructionComponent } from './construction/construction.component';
import { PharmaceuticalComponent } from './pharmaceutical/pharmaceutical.component';
import { MotorwaysComponent } from './motorways/motorways.component';
import { ManufacturingComponent } from './manufacturing/manufacturing.component';
import { LogisticsComponent } from './logistics/logistics.component';
import { PetrochemicalsComponent } from './petrochemicals/petrochemicals.component';
import { WhitePapersComponent } from './white-papers/white-papers.component';

import { QuartHeureSecuriteComponent } from './quart-heure-securite/quart-heure-securite.component';
import { EventsComponent } from './events/events.component';
import { FoodComponent } from './food/food.component';
import { DigitalLearningComponent } from './digital-learning/digital-learning.component';
import { PressComponent } from './press/press.component';
import { JourneeSecuriteComponent } from './journee-securite/journee-securite.component';
import { DownloadPageComponent } from './download-page/download-page.component';
import { DemoComponent } from './demo/demo.component';
import { UniversityComponent } from './university/university.component';
import { WasteManagementComponent } from './waste-management/waste-management.component';
import { HealthComponent } from './health/health.component';
import { FormationComponent } from './formation/formation.component';
import { AccueilSecuriteComponent } from './accueil-securite/accueil-securite.component';
import { JourneeSecuriteWorkshopsComponent } from './journee-securite-workshops/journee-securite-workshops.component';
import { SafetyboxComponent } from './safetybox/safetybox.component';
import { EchangeFormationComponent } from './echange-formation/echange-formation.component';
import { InterviewsComponent } from './interviews/interviews.component';
import { InterviewPageComponent } from './interview-page/interview-page.component';

const routes: Routes = [

    { path : 'page-training/:name', redirectTo : 'content/:name'},
    { path : 'actualite/:articleId', redirectTo : 'blog/:articleId'},
    { path : 'RandD/:articleId', redirectTo : 'research-innovation/:articleId'},
    { path : 'contact', redirectTo : 'about-us'},
    { path : 'prices', redirectTo : 'subscription'},
    { path : 'fr/tarif', redirectTo : 'fr/abonnement'},


    {
        path : 'fr',
        children : [
            { path : 'basket',    loadChildren: () => import('./basket/basket.module').then(m => m.BasketModule) },
            { path : 'legal',        loadChildren: () => import('./legal/legal.module').then(m => m.LegalModule) },
            { path : 'safetybox-vr',                        component : SafetyboxComponent,     pathMatch:"full" },
            { path : 'interviews',                          component : InterviewsComponent,    pathMatch:"full" },
            { path : 'interviews/:articleId',               component : InterviewPageComponent, pathMatch:"full" },
            { path : 'echangeformation',                    component : EchangeFormationComponent,     pathMatch:"full" },
            { path : 'echangeformation/:action',            component : EchangeFormationComponent,       pathMatch:"full" },
            { path : 'accueil-securite',                    component : AccueilSecuriteComponent,     pathMatch:"full" },
            { path : 'formation-vr-sst',                    component : FormationComponent,     pathMatch:"full" },
            { path : 'industrie-gestion-dechets',           component : WasteManagementComponent,  pathMatch:"full" },
            { path : 'journee-securite',                    component : JourneeSecuriteComponent,  pathMatch:"full" },
            { path : 'nos-contributeurs',                   component : JourneeSecuriteWorkshopsComponent,  pathMatch:"full" },
            { path : 'industrie-agroalimentaire',           component : FoodComponent,          pathMatch:"full" },
            { path : 'formation-digitale',                  component : DigitalLearningComponent,  pathMatch:"full" },
            // { path : 'communiques-de-presse',               component : PressComponent,         pathMatch:"full" },
            { path : 'industrie-sante',                     component : HealthComponent,        pathMatch:"full" },
            { path : 'industrie-universite',                component : UniversityComponent,    pathMatch:"full" },
            { path : 'industrie-construction',              component : ConstructionComponent,  pathMatch:"full" },
            { path : 'industrie-pharmaceutique',            component : PharmaceuticalComponent,pathMatch:"full" },
            { path : 'industrie-securite-routiere',         component : MotorwaysComponent,     pathMatch:"full" },
            { path : 'industrie-manufacturiere',            component : ManufacturingComponent, pathMatch:"full" },
            { path : 'industrie-logistique',                component : LogisticsComponent,     pathMatch:"full" },
            { path : 'industrie-petrochimie',               component : PetrochemicalsComponent,pathMatch:"full" },
            { path : 'campus-virtuel',                      component : SecurityDayComponent,   pathMatch:"full" },
            { path : 'livres-blancs',                       component : WhitePapersComponent,   pathMatch:"full" },
            { path : 'quart-heure-securite',                component : QuartHeureSecuriteComponent,   pathMatch:"full" },
            { path : 'evenements',                          component : EventsComponent,        pathMatch:"full" },
            { path : 'recherche-innovation',                component : RdComponent,            pathMatch:"full" },
            { path : 'recherche-innovation/:articleId',     component : RdPageComponent,        pathMatch:"full" },
            { path : 'actualites',                          component : ActualitesComponent,    pathMatch:"full" },
            { path : 'actualites/:articleId',               component : ActualiteComponent,     pathMatch:"full" },
            { path : 'faq',                                 component : FaqPageComponent,       pathMatch:"full" },
            { path : 'content',                             component : ProductsComponent,      pathMatch:"full" },
            { path : 'content/:name',                       component : ProductPageComponent,   pathMatch:"full" },
            { path : 'a-propos',                            component : AboutUsComponent,       pathMatch:"full" },
            { path : 'a-propos/:action',                    component : AboutUsComponent,       pathMatch:"full" },
            { path : 'abonnement',                          component : TarifsComponent,        pathMatch:"full" },
            { path : 'register',                            component : RegisterComponent,      pathMatch:"full" },
            { path : 'register/:param',                     component : RegisterComponent,      pathMatch:"full" },
            { path : 'recrutement',                         component : JobsComponent,          pathMatch:"full" },
            { path : 'recrutement/:jobId',                  component : JobComponent,           pathMatch:"full" },
            { path : 'rp/:token',                           component : ResetPasswordComponent, pathMatch:"full" },
            // { path : 'downloads',                           component : DownloadPageComponent,  pathMatch:"full" },
            { path : 'demo',                                component : DemoComponent,          pathMatch:"full" },
            { path : '**',                                  redirectTo : "/fr",                 pathMatch:"full" }
        ]
    },
    {
        path : '',
        children : [
            { path : 'basket',    loadChildren: () => import('./basket/basket.module').then(m => m.BasketModule) },
            { path : 'legal',        loadChildren: () => import('./legal/legal.module').then(m => m.LegalModule) },
            { path : 'safetybox-vr',                        component : SafetyboxComponent,     pathMatch:"full" },
            { path : 'interviews',                          component : InterviewsComponent,    pathMatch:"full" },
            { path : 'interviews/:articleId',               component : InterviewPageComponent, pathMatch:"full" },
            { path : 'echangeformation',                    component : EchangeFormationComponent,     pathMatch:"full" },
            { path : 'echangeformation/:action',            component : EchangeFormationComponent,       pathMatch:"full" },
            { path : 'security-welcome',                    component : AccueilSecuriteComponent,     pathMatch:"full" },
            { path : 'vr-training-osh',                     component : FormationComponent,     pathMatch:"full" },
            { path : 'industry-waste-management',           component : WasteManagementComponent,  pathMatch:"full" },
            { path : 'safety-day',                          component : JourneeSecuriteComponent,  pathMatch:"full" },
            { path : 'our-contributors',                    component : JourneeSecuriteWorkshopsComponent,  pathMatch:"full" },
            { path : 'industry-food',                       component : FoodComponent,          pathMatch:"full" },
            { path : 'digital-learning',                    component : DigitalLearningComponent,  pathMatch:"full" },
            // { path : 'press-releases',                      component : PressComponent,         pathMatch:"full" },
            { path : 'industry-health',                     component : HealthComponent,        pathMatch:"full" },
            { path : 'industry-university',                 component : UniversityComponent,    pathMatch:"full" },
            { path : 'industry-construction',               component : ConstructionComponent,  pathMatch:"full" },
            { path : 'industry-pharmaceutical',             component : PharmaceuticalComponent,pathMatch:"full" },
            { path : 'industry-road-safety',                component : MotorwaysComponent,     pathMatch:"full" },
            { path : 'industry-manufacturing',              component : ManufacturingComponent, pathMatch:"full" },
            { path : 'industry-logistics',                  component : LogisticsComponent,     pathMatch:"full" },
            { path : 'industry-petrochemicals',             component : PetrochemicalsComponent,pathMatch:"full" },
            { path : 'virtual-campus',                      component : SecurityDayComponent,   pathMatch:"full" },
            { path : 'white-papers',                        component : WhitePapersComponent,   pathMatch:"full" },
            { path : 'safety-quarter-hour',                 component : QuartHeureSecuriteComponent,   pathMatch:"full" },
            { path : 'events',                              component : EventsComponent,        pathMatch:"full" },
            { path : 'research-innovation',                 component : RdComponent,            pathMatch:"full" },
            { path : 'research-innovation/:articleId',      component : RdPageComponent,        pathMatch:"full" },
            { path : 'blog',                                component : ActualitesComponent,    pathMatch:"full" },
            { path : 'blog/:articleId',                     component : ActualiteComponent,     pathMatch:"full" },
            { path : 'faq',                                 component : FaqPageComponent,       pathMatch:"full" },
            { path : 'content',                             component : ProductsComponent,      pathMatch:"full" },
            { path : 'content/:name',                       component : ProductPageComponent,   pathMatch:"full" },
            { path : 'about-us',                            component : AboutUsComponent,       pathMatch:"full" },
            { path : 'about-us/:action',                    component : AboutUsComponent,       pathMatch:"full" },
            { path : 'subscription',                        component : TarifsComponent,        pathMatch:"full" },
            { path : 'register',                            component : RegisterComponent,      pathMatch:"full" },
            { path : 'register/:param',                     component : RegisterComponent,      pathMatch:"full" },
            { path : 'jobs',                                component : JobsComponent,          pathMatch:"full" },
            { path : 'jobs/:jobId',                         component : JobComponent,           pathMatch:"full" },
            { path : 'rp/:token',                           component : ResetPasswordComponent, pathMatch:"full" },
            // { path : 'downloads',                           component : DownloadPageComponent,  pathMatch:"full" },
            { path : 'demo',                                component : DemoComponent,          pathMatch:"full" },
            { path : '**',                                  redirectTo : "/",                   pathMatch:"full" }


        ]
    }

];

@NgModule({
    declarations: [
        AboutUsComponent,
        ActualiteComponent,
        ActualitesComponent,
        FaqPageComponent,
        JobComponent,
        JobsComponent,
        ProductPageComponent,
        ProductsComponent,
        RdComponent,
        RdPageComponent,
        RegisterComponent,
        SecurityDayComponent,
        TarifsComponent,
        ResetPasswordComponent,
        ConstructionComponent,
        PharmaceuticalComponent,
        MotorwaysComponent,
        ManufacturingComponent,
        LogisticsComponent,
        PetrochemicalsComponent,
        WhitePapersComponent,
        QuartHeureSecuriteComponent,
        EventsComponent,
        FoodComponent,
        DigitalLearningComponent,
        PressComponent,
        JourneeSecuriteComponent,
        DownloadPageComponent,
        DemoComponent,
        UniversityComponent,
        WasteManagementComponent,
        HealthComponent,
        FormationComponent,
        AccueilSecuriteComponent,
        JourneeSecuriteWorkshopsComponent,
        SafetyboxComponent,
        EchangeFormationComponent,
        InterviewsComponent,
        InterviewPageComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        RouterModule.forChild(routes)
    ]
})
export class PublicModule { }
